// Gold laurel wreath around a festival selection / award.
const LEAVES = [0, 1, 2, 3, 4, 5, 6];

const Branch = ({ flip }) => (
  <svg viewBox="0 0 30 80" className="h-16 w-6 shrink-0 text-gold" style={flip ? { transform: "scaleX(-1)" } : undefined} aria-hidden="true">
    <path d="M24 76 C8 60 6 30 18 4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    {LEAVES.map((i) => {
      const t = i / (LEAVES.length - 1);
      const y = 70 - t * 62;
      const x = 21 - Math.sin(t * Math.PI) * 11 + t * 2;
      return <ellipse key={i} cx={x - 4} cy={y} rx="5.5" ry="2.3" fill="currentColor" transform={`rotate(${-35 - t * 25} ${x - 4} ${y})`} />;
    })}
  </svg>
);

export function Laurel({ laurel, index }) {
  return (
    <div className="flex items-center gap-0.5" data-testid={`laurel-${index}`}>
      <Branch />
      <div className="text-center max-w-[150px] px-1">
        <p className="text-[10px] uppercase tracking-[0.18em] text-gold font-bold leading-tight">{laurel.award}</p>
        <p className="font-display text-sm font-bold text-foreground leading-tight mt-0.5 line-clamp-2">{laurel.festival}</p>
        {laurel.year && <p className="text-[10px] text-foreground/60 mt-0.5 tabular-nums">{laurel.year}</p>}
      </div>
      <Branch flip />
    </div>
  );
}

export default function Laurels({ laurels = [] }) {
  if (!laurels.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-3" data-testid="film-laurels">
      {laurels.map((l, i) => <Laurel key={`${l.festival}-${i}`} laurel={l} index={i} />)}
    </div>
  );
}
